import { takeLatest, call, put, all } from 'redux-saga/effects';
import api from '../../../services/API';
import {
  atualizarPerfilSucesso,
  atualizarPerfilFalhou,
  resgatarPremioSucesso,
  resgatarPremioFalhou,
  aceitarRegulamento,
  aceitarPrivacidade,
  alterarStatusCartao,
  atualizarSaldo,
  atualizarCluster,
} from './actions';

import { toast } from 'react-toastify';
import historico from '../../../services/Historico';

export function* buscarDados() {
  try {
    const response = yield call(api.get, '/api/sessoes/parceiro/info');

    yield put(atualizarSaldo(response.data.saldoPontos));
    yield put(atualizarCluster(response.data));
  } catch (err) {
    console.error('Erro ao atualizar o saldo', err);
  }
}

export function* atualizarPerfil({ payload }) {
  try {
    const tutorial = payload?.nav ?? false;
    delete payload.nav;

    const response = yield call(api.put, '/api/parceiros', payload);

    yield put(atualizarPerfilSucesso(response.data));
    if (!tutorial)
      toast.success('Dados atualizado com sucesso', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
  } catch (err) {
    yield put(atualizarPerfilFalhou());
  }
}

export function* atualizarPerfilFoto({ payload }) {
  const { arquivo, idParceiro, setShowModal } = payload;
  const formData = new FormData();
  formData.append('arquivo', arquivo[0]);
  formData.append('idParceiro', idParceiro);
  const response = yield call(api.post, '/api/upload/parceiro_foto', formData);
  if (response?.status === 200) {
    toast.success('Foto adicionada com sucesso.', {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 10000,
    });
    yield put(atualizarPerfilSucesso(response.data));
    setShowModal(false);
  } else {
    yield put(atualizarPerfilFalhou());
  }
}

export function* getParceiro() {
  try {
    const response = yield call(api.get, '/api/sessoes/parceiro/info');
    yield put(atualizarPerfilSucesso(response.data));
  } catch (err) {}
}
export function* resgatarPremio({ payload }) {
  const { codigoPremio, qtde, obs, enderecoEntrega } = payload;

  try {
    const response = yield call(api.post, '/api/resgatar', {
      codigoPremio,
      qtde,
      obs,
      enderecoEntrega,
    });

    yield put(resgatarPremioSucesso(response.data));

    toast.success('Resgate realizado com sucesso!', {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 10000,
    });
    toast.success(
      `Seu saldo atual é de ${Number(response.data.saldoNovo).toLocaleString(
        'pt-BR'
      )} pontos`,
      {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      }
    );
    historico.push('/resgates');
  } catch (err) {
    yield put(resgatarPremioFalhou());
  }
}

export function* aceitouRegulamento() {
  yield call(api.put, '/api/parceiros', { aceitouRegulamento: 1 });
  put(aceitarRegulamento());
}

export function* aceitouPrivacidade() {
  yield call(api.put, '/api/parceiros', { aceitouPrivacidade: 1 });
  put(aceitarPrivacidade());
}

export function statusCartao({ payload }) {
  put(alterarStatusCartao(payload));
}

export default all([
  takeLatest('@parceiro/ATUALIZAR_PERFIL', atualizarPerfil),
  takeLatest('@parceiro/RESGATAR_PREMIO', resgatarPremio),
  takeLatest('@parceiro/ACEITAR_REGULAMENTO', aceitouRegulamento),
  takeLatest('@parceiro/ACEITAR_PRIVACIDADE', aceitouPrivacidade),
  takeLatest('@parceiro/ALTERAR_STATUS_CARTAO', statusCartao),
  takeLatest('@parceiro/BUSCAR_DADOS', buscarDados),
  takeLatest('@parceiro/GET_PARCEIRO', getParceiro),
  takeLatest('@parceiro/ATUALIZAR_PERFIL_FOTO', atualizarPerfilFoto),
]);
